
















































import { StakingViewModel } from "@/modules/staking/viewmodels/staking-viewmodel";
import { Observer } from "mobx-vue";
import { Component, Inject, Vue } from "vue-property-decorator";
@Observer
@Component({
  components: {},
})
export default class HarvestDialog extends Vue {
  @Inject() vm!: StakingViewModel;
}
